import { render, staticRenderFns } from "./dblv.vue?vue&type=template&id=04e14d7d&scoped=true&"
import script from "./dblv.vue?vue&type=script&lang=js&"
export * from "./dblv.vue?vue&type=script&lang=js&"
import style0 from "./dblv.vue?vue&type=style&index=0&id=04e14d7d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e14d7d",
  null
  
)

export default component.exports